import { cn } from '../../lib/cn';

type Props = {
  steps: { label: string; order: number }[];
  currentStep: number;
  className?: string;
};

export function OnboardingStepper({ steps, currentStep, className }: Props) {
  return (
    <ol className={cn('flex flex-wrap gap-2', className)} aria-label="Onboarding progress">
      {steps.map((s) => {
        const done = s.order < currentStep;
        const active = s.order === currentStep;
        return (
          <li
            key={s.label}
            aria-current={active ? 'step' : undefined}
            className={cn(
              'rounded-full px-3 py-1 text-xs font-medium transition-colors duration-200',
              active && 'bg-brand-600 text-white',
              done && !active && 'bg-success-100 text-success-800 dark:bg-success-950 dark:text-success-300',
              !done && !active && 'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-400',
            )}
          >
            {s.label}
          </li>
        );
      })}
    </ol>
  );
}
